import { useState } from "react";
import './EventGallery.css'
import useMeta from '../../../hooks/useMeta';

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import Footer from "../../../CommonComponent/Footer/footer";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

import { useParams } from "react-router-dom";
import { EventGalleryIMAGES } from "../EventGallery_Data";

const EventGallery = () => {

    const { EventID } = useParams();
    const EventImages = EventGalleryIMAGES[EventID]?.images || null;
    const page_title = EventGalleryIMAGES[EventID]?.pg_title || null;

    const Meta_title = EventGalleryIMAGES[EventID]?.Meta_title || null;

    const Meta_OG_description = EventGalleryIMAGES[EventID]?.Meta_OG_description || null;

    const canonical_OG_url = EventGalleryIMAGES[EventID]?.canonical_OG_url || null;


    useMeta({
        title: Meta_title,  
        description: Meta_OG_description,
        canonical: canonical_OG_url,
        og: {
            locale: 'en_US',
            type: 'article',
            title: page_title,
            description:
                Meta_OG_description,
            url: canonical_OG_url,
            site_name: 'Marvel Blinds',
        },
    });

    // State for preview
    const [previewImage, setPreviewImage] = useState(null);

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="EventGallery_pg_wrapper">
                <div className="EventGallery_pg_container">
                    {page_title && (
                        <div className="Page-Main_Dec EventGallery_devider">
                            <h1 className="Page-title_LowerCase">{page_title}</h1>
                        </div>
                    )}
                    <div className="EventGallery_pg_content">
                        <div className="Event_images_grid">
                            {EventImages.map((src, index) => (
                                <div
                                    className="Event_image_card"
                                    id={`img_card_${index}`}
                                    key={index}
                                    onClick={() => setPreviewImage(src)} // On click open preview
                                >
                                    <img
                                        src={src}
                                        alt={`gallery-${index}`}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Preview modal */}
            {previewImage && (
                <div className="image-preview-overlay" onClick={() => setPreviewImage(null)}>
                    <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="image-preview-close"
                            onClick={() => setPreviewImage(null)}
                        >
                            ✖
                        </button>
                        <img src={previewImage} alt="preview" className="image-preview" />
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
};

export default EventGallery;
